import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Util from "../../../utils/utils";


const ErrorModal = ( { show, handleRefresh, title, message, iconName, style, buttonStatus } ) =>
{
	function handleLogout ()
	{
		Util.clearAll();
		window.location.href = "/login"
	}

	return (
		<Modal
			show={show}
			onHide={handleRefresh}
			backdrop="static"
			keyboard={false}
			dialogClassName="modal-dialog-centered m-auto">
			<Modal.Header className="flex-column">
				<div className="icon-box">
					<i className={"fa " + iconName} style={style}/>
				</div>
				<Modal.Title className="modal-title" style={{
					"marginTop" : "20px",
					"direction" : "rtl"
				}}>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p style={{ "direction" : "rtl" }}>
					{message}
				</p>
			</Modal.Body>
			<Modal.Footer className="justify-content-center">
				{
					buttonStatus && <Button onClick={handleRefresh}>
						بروزرسانی
					</Button>
				}
				{
					buttonStatus &&
					<Button onClick={handleLogout}>
						خروج
					</Button>
				}
			</Modal.Footer>
		</Modal>
	);
};

export default ErrorModal;
